export default "__VITE_ASSET__QCK46eml__"